import FilterBase from "./base";

export default class FilterMoreApartmentsModule extends FilterBase {
    constructor(config, notification) {
        super(config, notification, "moreApartmentsSelect", "moreApartmentComponentDisabled");
        if (this.component === null) {
            return;
        }
        this.checkboxes = this.component.querySelectorAll('.items-list__column input[type="checkbox"]');
        this.inputs = this.component.querySelectorAll('.items-list__column input[type="number"]');
        this.bindCloseButton(this.onCloseFilter);
        this.bindClearFiltersButton(this.onClearFilter);
        this.bindCheckboxCheck();
        const searchParams = new URLSearchParams(config.settings.savedFilters);
        let fFeatures = searchParams.getAll("aFeatures");
        if (fFeatures !== null) {
            let featuresIdsArr = [];
            let featuresValuesArr = [];
            fFeatures.forEach((fFeature) => {
                const featureItem = fFeature.split(";");
                if (featureItem.length > 1) {
                    featuresIdsArr.push(featureItem[0]);
                    featuresValuesArr.push(featureItem[1]);
                }
            });
            this.checkboxes.forEach((checkbox) => {
                if (featuresIdsArr.includes(checkbox.value)) {
                    checkbox.checked = 1;
                    this.addItemToList(checkbox);
                }
            });
            if (true) {
                this.inputs.forEach((input) => {
                    if (featuresIdsArr.includes(input.dataset.filterId)) {
                        const index = featuresIdsArr.indexOf(input.dataset.filterId);
                        if (index !== -1) {
                            const value = featuresValuesArr[index];
                            input.value = value;
                            //              this.addItemToList(input);
                        }
                    }
                });
            }
        }
        this.updateInput();
    }

    updateInput = () => {
        switch (this.selectedData.length) {
            case 0:
                this.input.value = "";
                this.hideCounter();
                break;

            case 1:
                this.input.value = this.selectedData[0].name;
                this.hideCounter();
                break;

            default:
                this.input.value = "Wybrane cechy";
                this.showCounter();
                break;
        }
    };

    getData = () => {
        const squareFootage = this.mainContainer.querySelector(
            'input[name="squareFootage"]'
        );
        const singleBeds = this.mainContainer.querySelector(
            'input[name="singleBeds"]'
        );
        const doubleBeds = this.mainContainer.querySelector(
            'input[name="doubleBeds"]'
        );
        const inputs = [];

        this.inputs.forEach((input) => {
            if (input.value !== "" && parseInt(input.value) !== 0) {
                inputs.push({
                    id: input.dataset.filterId,
                    value: input.value,
                });
            }
        });

        return {
            features: {
                checkboxes: this.selectedData,
                inputs: inputs,
            },
            squareFootage,
            singleBeds,
            doubleBeds,
        };
    };
}
